import type { AccessibleSVGProps } from '@core/svg'
import { AccessibleSVG } from '@core/svg'

/**
 * Image placeholder SVG Icon for image attachment.
 */
export const ImagePlaceholder: React.FC<AccessibleSVGProps> = (props) => (
  <AccessibleSVG
    width="100%"
    height="100%"
    viewBox="0 0 18 14"
    aria-hidden={true}
    {...props}
  >
    <path
      d="M16.5682 0H0.613636C0.274219 0 0 0.274219 0 0.613636V12.8864C0 13.2258 0.274219 13.5 0.613636 13.5H16.5682C16.9076 13.5 17.1818 13.2258 17.1818 12.8864V0.613636C17.1818 0.274219 16.9076 0 16.5682 0ZM15.8011 12.1193H1.38068V11.3542L4.03658 8.20355L6.91492 11.6169L11.3925 6.30895L15.8011 11.5364V12.1193ZM15.8011 9.63026L11.5095 4.54091C11.4482 4.46804 11.3369 4.46804 11.2756 4.54091L6.91492 9.7108L4.15355 6.43743C4.09219 6.36456 3.98097 6.36456 3.9196 6.43743L1.38068 9.44808V1.38068H15.8011V9.63026ZM4.60227 5.67614C4.82388 5.67614 5.04331 5.63249 5.24805 5.54768C5.45279 5.46288 5.63882 5.33858 5.79552 5.18188C5.95221 5.02518 6.07651 4.83915 6.16132 4.63441C6.24612 4.42968 6.28977 4.21024 6.28977 3.98864C6.28977 3.76703 6.24612 3.5476 6.16132 3.34286C6.07651 3.13812 5.95221 2.95209 5.79552 2.79539C5.63882 2.63869 5.45279 2.51439 5.24805 2.42959C5.04331 2.34478 4.82388 2.30114 4.60227 2.30114C4.15472 2.30114 3.7255 2.47893 3.40903 2.79539C3.09256 3.11186 2.91477 3.54108 2.91477 3.98864C2.91477 4.43619 3.09256 4.86541 3.40903 5.18188C3.7255 5.49835 4.15472 5.67614 4.60227 5.67614ZM4.60227 3.4517C4.8995 3.4517 5.1392 3.69141 5.1392 3.98864C5.1392 4.28587 4.8995 4.52557 4.60227 4.52557C4.30504 4.52557 4.06534 4.28587 4.06534 3.98864C4.06534 3.69141 4.30504 3.4517 4.60227 3.4517Z"
      fill={props.fill ?? 'currentColor'}
    />
  </AccessibleSVG>
)
